import axios from '@/plugins/axios'

export function getQuestions(params = {}) {
  return axios.get('feedback', {
    params,
  })
}

export function isReadChange(params = {}) {
  return axios.get('feedback/isReadChange', {
    params,
  })
}
